import type { IFilePayload } from 'src/types/IFilePayload';
import type { IFileReference } from 'src/types/IFileReference';

export function fileReferencesToFilePayloads(files: IFileReference[]): IFilePayload[] {
  return files.map((file) => ({
    uid: file.id,
    fileName: file.fileName,
    contentType: file.contentType,
  }));
}
